import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ModifyLMTOrderComponent from './ModifyLMTOrderComponent';
import * as commonActions from './../../actions/commonActions';
import * as tradeBookActions from './../../actions/tradeBookActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as activityActions from './../../actions/activityActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as reportActions from './../../actions/reportActions';
import * as authActions from '../../redux/modules/auth';
import styles from './../TradeBook/TradeBook.less';
import config from './../../config';
import Modal from 'react-modal';
import {ButtonToolbar,  DropdownButton,  MenuItem, Button} from 'react-bootstrap';
import { Card } from 'reactstrap';
import {Grid,DragDropProvider,Table,TableHeaderRow,TableColumnReordering,ColumnChooser,TableColumnVisibility,SearchPanel,
  Toolbar,TableSelection} from '@devexpress/dx-react-grid-bootstrap4';
import {SortingState,IntegratedSorting,  SearchState, IntegratedFiltering,SelectionState,IntegratedSelection} from '@devexpress/dx-react-grid';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import numeral  from 'numeral';
import { getAccountByCode, getCountofTableRows, getInactiveAccounts, setDirection,unformatLang } from './../../utils/utils';
import { withStyles } from '@material-ui/core/styles';
import {Getter,Plugin} from '@devexpress/dx-react-core';
import i18next from 'i18next';
import appConstants from './../../appConstants';
import track from 'react-tracking';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
import { displayInActiveAccMsg } from '../../utils/validation';

// const elementsData = [
//   {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"dropdown-menu", "elementType":"normal", "applyTo":"all", "tagNames":"li"},
//   {"classNames":"form-control","elementType":"tag", "applyTo":"all", "tagNames":"input"},
//   {"classNames":"oi-eye","elementType":"tag", "applyTo":"all", "tagNames":"span"},
//   {"classNames":"lmtOrdDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"noDataColor", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"dx-g-bs4-table-container","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"widgetwrapper", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"dropdown-item", "elementType":"normal", "applyTo":"all", "tagNames":"button"}
// ];

const directionData=[
  {"classNames":"card-header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"widgetwrapper", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"refresh_icon", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"lmtOrderStatus", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"orderRowsCount", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"modalCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdbookText", "elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"btnText", "elementType":"normal", "applyTo":"all", "tagNames":"button"}
];

const getRowId = row => row;

let ordRectFlag=false;
let selectedRowsToCancel = [];
let wsData;

let compareRate = (a, b) => {
  let result;
  if (numeral(a)._value < numeral(b)._value) {
    result = -1;
  } else{
    result = 1;
  }
  return result;
};

const rowSelectionEnabled = row => row.status === "Outstanding";
class PatchedIntegratedSelection extends React.Component {
  render() {
    const { rowSelectionEnabled, ...restProps } = this.props;
    return (
      <Plugin>
        <Getter
          name="rows"
          computed={({ rows }) => {
            this.rows = rows;
            return rows.filter(rowSelectionEnabled);
          }}
        />
        <IntegratedSelection {...restProps} />
        <Getter
          name="rows"
          computed={() => this.rows}
        />
      </Plugin>
    )
  }
};

class PatchedTableSelection extends React.Component {
  render() {
    const { rowSelectionEnabled, ...restProps } = this.props;
    return (
      <TableSelection
        cellComponent={(props) => this.props.rowSelectionEnabled(props.tableRow.row) ?
          (
            <TableSelection.Cell {...props} />
          )
        :
          (
            <Table.StubCell {...props} />
          )
        }
        {...restProps}
      />
    );
  }
}

@connect(state => ({
  ACD: state.auth.ACD,
  limitOrdBook:state.dashboardRoot.activityReducer.limitOrdBook,
  lmtModifyFlag:state.dashboardRoot.tradeBookReducer.lmtModifyFlag,
  closeLmtModifypopup:state.dashboardRoot.tradeBookReducer.closeLmtModifypopup,
  ordersCTID:state.dashboardRoot.activityReducer.ordersCTID,
  userDetail:state.auth.userDetail,
  getAllOrdersTrd:state.dashboardRoot.tradeBookReducer.getAllOrdersTrd,
  ordersRandomNoDB:state.dashboardRoot.activityReducer.ordersRandomNoDB,
  orderBookLoaderFlag:state.dashboardRoot.activityReducer.orderBookLoaderFlag,
  actLogRandomNo:state.dashboardRoot.activityReducer.actLogRandomNo,
  limitOrdMap:state.dashboardRoot.activityReducer.limitOrdMap,
  status:state.dashboardRoot.instrumentListReducer.status,
  requestRejectModal:state.dashboardRoot.activityReducer.requestRejectModal,
  socketData:state.dashboardRoot.instrumentListReducer.socketData,
  tradeBookColumns:state.dashboardRoot.dashboardReducer.tradeBookColumns,
  language:state.dashboardRoot.commonReducer.language,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  checkClickOnAddWidgetFlag:state.dashboardRoot.commonReducer.checkClickOnAddWidgetFlag,
  fontSize:state.auth.userDetail.fontSize,
  allowLMT_PF:state.auth.allowLMT_PF,
  navigationStatus:state.dashboardRoot.commonReducer.navigationStatus,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  orderSelectionFlag:state.dashboardRoot.tradepanelReducer.orderSelectionFlag,
  statusChanged:state.dashboardRoot.activityReducer.statusChanged,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  disableOrdModify:state.auth.disableOrdModify,
}), {
  ...reportActions,...commonActions,...tradeBookActions, ...dashboardActions,...activityActions,...tradepanelActions,...authActions
})

@track(() => ({ widgetDetails: { tab: i18next.t('orderBook') }}))

export default class LimitOrderTableComponent extends Component {
  static propTypes = {
    limitOrdBook:PropTypes.array,
    userDetail:PropTypes.object,
    orderBookLoaderFlag:PropTypes.bool,
    lmtModifyFlag:PropTypes.bool,
    requestRejectModal:PropTypes.object,
    ordersCTID:PropTypes.array,
    handleCancelledLMT:PropTypes.func,
    validateOrder:PropTypes.func,
    handleLimitModal:PropTypes.func,
    orderRefreshFlag:PropTypes.func,
    updateTrdBookCols:PropTypes.func,
    layoutChanged:PropTypes.func,
    tradeBookColumns:PropTypes.array,
    language:PropTypes.string,
    allowLMT_PF:PropTypes.bool,
    navigationStatus:PropTypes.string,
    getInvoice:PropTypes.func,
    CloseIcon:PropTypes.object.isRequired,
    orderSelectionFlag:PropTypes.bool,
    orderSelectionFunc:PropTypes.func,
    statusChanged:PropTypes.array,
  };
  state = {
    limitOrdMap:null,
    selectLMT:'outstanding',
    selectLMTKey:"O",
    randomNo:0,
    outstngLmtOrderRows:[],
    lmtOrderFilledrows:[],
    lmtCancelledOrderRows:[],
    lmtExpiredOrderRows:[],
    allLmtOrdersRows:[],
    allLmtOrderColumns:[],
    allLmtOrderColumnExtensions:[
      {columnName:'eventTime', width:170},
      {columnName:'status', width:100},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:105},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:80},
      {columnName:'rate', width:100, align:'right'},
      {columnName:'validity', width:145},
      {columnName:'orderNo', width:140},
      {columnName:'docNo', width:140},
      {columnName:'placedBy', width:100},
      {columnName:'action', width:23}
    ],
    allLmtOrderColumnExtensionsAR:[
      {columnName:'eventTime',width:170, align:'right'},
      {columnName:'status', width:100, align:'right'},
      {columnName:'deal', width:80, align:'right'},
      {columnName:'cmdtyPair', width:105, align:'right'},
      {columnName:'quantity', width:100, align:'left'},
      {columnName:'qtyType', width:80, align:'right'},
      {columnName:'rate', width:100, align:'left'},
      {columnName:'validity', width:145, align:'right'},
      {columnName:'orderNo', width:140, align:'right'},
      {columnName:'docNo', width:140, align:'right'},
      {columnName:'placedBy', width:100, align:'right'},
      {columnName:'action', width:23}
    ],
    outLmtOrdcolumns:[],
    outLmtOrdColumnExtensions:[],
    outLmtOrdColumnExtensionsAR:[],
    filledLmtOrderColumns:[],
    filledLmtOrdColumnExtensions:[
      { columnName:'eventTime', width:170},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:115},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:84},
      {columnName:'rate', width:100, align:'right'},
      {columnName:'validity', width:145},
      {columnName:'docNo', width:130},
      {columnName:'orderNo', width:130},
      {columnName:'valDate', width:100, align:'right'},
      {columnName:'placedBy', width:100},
      
    ],
    filledLmtOrdColumnExtensionsAR:[
      {columnName:'eventTime', width:170, align:'right'},
      {columnName:'deal', width:80, align:'right'},
      {columnName:'cmdtyPair', width:141, align:'right'},
      {columnName:'quantity', width:100, align:'left'},
      {columnName:'qtyType', width:84, align:'right'},
      {columnName:'rate', width:100, align:'left'},
      {columnName:'validity', width:145,},
      {columnName:'docNo', width:130},
      {columnName:'orderNo', width:130},
      {columnName:'valDate', width:100, align:'left'},
      {columnName:'placedBy', width:100, align:'right'},
    ],
    cancelledLmtOrderColumns:[],
    cancelledLmtOrdColumnExtensions:[
      {columnName:'eventTime', width:170},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:115},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:84},
      {columnName:'rate', width:100, align:'right'},
      {columnName:'validity', width:145},
      {columnName:'orderNo', width:130},
      {columnName:'placedBy', width:100},
      {columnName:'cancelledBy', width:100},
      {columnName:'accDescription', width:200},
    ],
    cancelledLmtOrdColumnExtensionsAR:[
      {columnName:'eventTime', width:170, align:'right'},
      {columnName:'deal', width:80, align:'right'},
      {columnName:'cmdtyPair', width:141, align:'right'},
      {columnName:'quantity', width:100, align:'left'},
      {columnName:'qtyType', width:84, align:'right'},
      {columnName:'rate', width:100, align:'left'},
      {columnName:'validity', width:145, align:'right'},
      {columnName:'orderNo', width:130},
      {columnName:'placedBy', width:100, align:'right'},
      {columnName:'cancelledBy', width:100, align:'right'},
      {columnName:'accDescription', width:200, align:'right'},
    ],
    expiredLmtOrderColumns:[],
    expiredLmtOrdColumnExtensions:[
      {columnName:'eventTime', width:170},
      {columnName:'deal', width:80},
      {columnName:'cmdtyPair', width:115},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:84},
      {columnName:'rate', width:100, align:'right'},
      {columnName:'validity', width:150},
      {columnName:'orderNo', width:130},
      {columnName:'placedBy', width:100},
      {columnName:'accDescription', width:200},
    ],
    expiredLmtOrdColumnExtensionsAR:[
      {columnName:'eventTime', width:170, align:'right'},
      {columnName:'deal', width:80, align:'right'},
      {columnName:'cmdtyPair', idth:141, align:'right'},
      {columnName:'quantity', width:100, align:'left'},
      {columnName:'qtyType', width:84, align:'right'},
      {columnName:'rate', width:100, align:'left'},
      {columnName:'validity', width:150, align:'right'},
      {columnName:'orderNo', width:130},
      {columnName:'placedBy', width:100, align:'right'},
      {columnName:'accDescription', width:200, align:'right'},
    ],
    integratedSortingColumnExtensions:[
      {columnName:'rate', compare:compareRate},
      {columnName:'quantity', compare:compareRate},
    ],
    // outLmtColumnOrder:['eventTime', 'orderNo', 'cmdtyPair', 'deal', 'quantity','outstanding','filled', 'price', 'accDescription', 'validity', 'comments'],
    allLmtColumnOrder:['eventTime', 'status', 'deal', 'cmdtyPair', 'quantity', 'qtyType', 'rate', 'validity', 'orderNo', 'docNo', 'placedBy', 'accDescription', 'comments'],
    filledLmtColOrder:['eventTime', 'deal', 'cmdtyPair', 'quantity', 'qtyType', 'rate', 'validity', 'docNo', 'orderNo', 'valDate', 'placedBy', 'accDescription', 'comments'],
    cancelledLmtColOrder:['eventTime', 'deal', 'cmdtyPair', 'quantity', 'qtyType', 'rate', 'validity', 'orderNo','placedBy', 'cancelledBy', 'accDescription',],
    expiredLmtColOrder:['eventTime', 'deal', 'cmdtyPair', 'quantity', 'qtyType', 'rate', 'validity', 'orderNo', 'placedBy', 'accDescription'],
    hiddenAllLmtOrderColNames:[],
    hiddenOutLmtColumnNames:[],
    hiddenFilledOrderColNames:[],
    hiddenCancelledLmtOrderColNames:[],
    hiddenExpiredColumnNames:[],
    outLmtSearchValue:'',
    allLmtSearchValue:'',
    filledLmtSearchValue:'',
    cancelledLmtSearchValue:'',
    expiedLmtSearchValue:'',
    outLmtColsSorting:[],
    allLmtColsSorting:[],
    filledLmtColsSorting:[],
    cancelledLmtColsSorting:[],
    expiredLmtColsSorting:[],
    selectedAllRowsData:[],
    statusFlag:false,
    disableModifyFlag:false,
    cancelLMTModel:false,
    refreshIconFlag:false,
    lmtOutstandingRandomNo:0,
    lmtFillRandomNo:0,
    lmtCancelledRandomNo:0,
    lmtExpiredRandomNo:0,
    colVisibilityExtensions:[
      {columnName:'action', togglingEnabled:false},
    ],
    selectedRowOrderNo:'',
    selectedOrderNo:'',
    selectedDocNo:'',
    ordbookTableRowCount:0,
    orderSelection:[],
    cancelModalExtensions:[
      {columnName:'orderNo', width:130},
      {columnName:'deal', width:75},
      {columnName:'cmdtyPair', width:105},
      {columnName:'quantity', width:100, align:'right'},
      {columnName:'qtyType', width:80},
      {columnName:'price', width:100, align:'right'},
      {columnName:'status_val', width:120},
      {columnName:'reason', width:405},
    ],
	  cancelModalExtensionsAR:[
      {columnName:'orderNo', width:130, align:'right'},
      {columnName:'deal', width:75, align:'right'},
      {columnName:'cmdtyPair', width:105, align:'right'},
      {columnName:'quantity', width:100, align:'left'},
      {columnName:'qtyType', width:80, align:'right'},
      {columnName:'price', width:100, align:'left'},
      {columnName:'status_val', width:120, align:'right'},
      {columnName:'reason', align:'right'},
    ],
    cancelModalColOrder:['orderNo', 'deal', 'cmdtyPair', 'quantity', 'qtyType', 'price', 'status_val', 'reason'],
    cancelModalSorting:[],
    cancelModalSearchValue:'',
    multipleCancelModal:false,
    cancelModalrow:[],
    stopBtnReplaceflag:false,
    checkMultiCnclStatusMdl:false,
    cancelAllDisableModal: false,
    inactiveAccOnOrders: []
  }

  constructor() {
    super();

    //allLmtOrder
    this.onChangeAllLmtColOrder = this.onChangeAllLmtColOrder.bind(this);
    this.onChangeAllLmtColSorting = this.onChangeAllLmtColSorting.bind(this);
    this.onChangeHiddenAllLmtCol = this.onChangeHiddenAllLmtCol.bind(this);
    this.onChangeAllLmtSearchValue = this.onChangeAllLmtSearchValue.bind(this);

    //outLmtOrder
    this.onChangeOutLmtColOrder = this.onChangeOutLmtColOrder.bind(this);
    this.onChangeOutLmtColSorting = this.onChangeOutLmtColSorting.bind(this);
    this.onChangeHiddenOutLmtCol = this.onChangeHiddenOutLmtCol.bind(this);
    this.onChangeOutLmtSearchValue = this.onChangeOutLmtSearchValue.bind(this);

    //filledLmtOrder
    this.onChangeFilledLmtColOrder=this.onChangeFilledLmtColOrder.bind(this);
    this.onChangeFillColSorting=this.onChangeFillColSorting.bind(this);
    this.onChangeHiddenFilledCol=this.onChangeHiddenFilledCol.bind(this);
    this.onChangeFilledSearchValue=this.onChangeFilledSearchValue.bind(this);

    //cancelled
    this.onChangeCancelColOrder=this.onChangeCancelColOrder.bind(this);
    this.onChangeCancelColSorting=this.onChangeCancelColSorting.bind(this);
    this.onChangeHiddenCancelCol=this.onChangeHiddenCancelCol.bind(this);
    this.onChangeCancelSearchValue=this.onChangeCancelSearchValue.bind(this);

    //Expired
    this.onChangeExpiredColOrder=this.onChangeExpiredColOrder.bind(this);
    this.onChangeExpiredColSorting=this.onChangeExpiredColSorting.bind(this);
    this.onChangeHiddenExpiredCol=this.onChangeHiddenExpiredCol.bind(this);
    this.onChangeExpiredSearchValue=this.onChangeExpiredSearchValue.bind(this);

    //coloumnSelection
    this.changeOutColSelection = this.changeOutColSelection.bind(this);
    this.changeAllColSelection = this.changeAllColSelection.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);

    //CancelModalGrid
    this.onChangeCancelModalSortiog=this.onChangeCancelModalSortiog.bind(this);
    this.onChangeCancelModalColOrder=this.onChangeCancelModalColOrder.bind(this);
    this.onChangeCancelModalSearchValue=this.onChangeCancelModalSearchValue.bind(this);
  }

  componentWillMount(){
    let outColsExtension=[];
    let outColsExtensionAR=[];
    if(this.props.allowLMT_PF === false){
      outColsExtension= [
        {columnName:'eventTime', width:180},
        {columnName:'orderNo', width:130},
        {columnName:'cmdtyPair', width:115},
        {columnName:'deal', width:75},
        {columnName:'quantity', width:100, align:'right'},
        {columnName:'qtyType', width:120},
        {columnName:'price', width:100, align:'right'},
        {columnName:'validity', width:120},
        {columnName:'placedBy', width:100},
        {columnName:'accDescription', width:150},
        {columnName:'action', width:23}
      ];
    } else {
      outColsExtension=[
        {columnName:'eventTime', width:180},
        {columnName:'orderNo', width:130},
        {columnName:'cmdtyPair', width:115},
        {columnName:'deal', width:75},
        {columnName:'quantity', width:100, align:'right'},
        {columnName:'qtyType', width:120},
        {columnName:'outstanding', width:100, align:'right'},
        {columnName:'filled', width:100, align:'right'},
        {columnName:'price', width:100, align:'right'},
        {columnName:'validity', width:120},
        {columnName:'placedBy', width:100},
        {columnName:'accDescription', width:150},
        {columnName:'action', width:23}
      ];
    }
    if(this.props.allowLMT_PF === false){
        outColsExtensionAR=[
          {columnName:'eventTime', width:180, align:'right'},
          {columnName:'orderNo', width:130, align:'right'},
          {columnName:'cmdtyPair', width:156, align:'right'},
          {columnName:'deal', width:75, align:'right'},
          {columnName:'quantity', width:100, align:'left'},
          {columnName:'qtyType', width:120, align:'right'},
          {columnName:'price', width:100, align:'left'},
          {columnName:'validity', width:120, align:'right'},
          {columnName:'placedBy', width:100, align:'right'},
          {columnName:'accDescription', width:150, align:'right'},
          {columnName:'action', width:23}
        ];
    } else {
      outColsExtensionAR=[
        {columnName:'eventTime', width:180, align:'right'},
        {columnName:'orderNo', width:130, align:'right'},
        {columnName:'cmdtyPair', width:156, align:'right'},
        {columnName:'deal', width:75, align:'right'},
        {columnName:'quantity', width:100, align:'left'},
        {columnName:'qtyType', width:120, align:'right'},
        {columnName:'outstanding', width:100, align:'left'},
        {columnName:'filled', width:100, align:'left'},
        {columnName:'price', width:100, align:'left'},
        {columnName:'validity', width:120, align:'right'},
        {columnName:'placedBy', width:100, align:'right'},
        {columnName:'accDescription', width:150, align:'right'},
        {columnName:'action', width:23}
      ];
    }
    this.setState({outLmtOrdColumnExtensions:outColsExtension});
    this.setState({outLmtOrdColumnExtensionsAR:outColsExtensionAR});
    this.setState({allLmtColumnOrder:this.props.tradeBookColumns.lmtOrderColumnOrder});
    this.setState({filledLmtColOrder:this.props.tradeBookColumns.lmtFilledOrderColumnOrder});
    this.setState({cancelledLmtColOrder:this.props.tradeBookColumns.lmtCancelledOrderColumnOrder});
    this.setState({expiredLmtColOrder:this.props.tradeBookColumns.lmtExpOrderColumnOrder});
    let lmtOutStandingOrderColumnOrder = this.props.tradeBookColumns.lmtOutStandingOrderColumnOrder;
    let lmtAllOrdColumnOrder = this.props.tradeBookColumns.lmtOrderColumnOrder;
    let lmtFillOrdColumnOrder = this.props.tradeBookColumns.lmtFilledOrderColumnOrder;
    let lmtExpiedOrdColumnOrder = this.props.tradeBookColumns.lmtExpOrderColumnOrder;
    let lmtCancelledOrdColumnOrder = this.props.tradeBookColumns.lmtCancelledOrderColumnOrder;
    var outColsArr =[];
    var allColsArr=[];
    var fillColsArr =[];
    var expColsArr=[];
    var cancellColsArr=[];
    for(let i=0 ; i< lmtOutStandingOrderColumnOrder.length ; i++){
      var obj ={};
      if(this.props.allowLMT_PF === false){
        if(lmtOutStandingOrderColumnOrder[i] === "outstanding"){
          lmtOutStandingOrderColumnOrder.splice(i, 1);
          i--;
        } else if (lmtOutStandingOrderColumnOrder[i] === "filled") {
          lmtOutStandingOrderColumnOrder.splice(i, 1);
          i--;
        } else {
          if(lmtOutStandingOrderColumnOrder[i] === "accDescription"){
            obj.name = lmtOutStandingOrderColumnOrder[i];
            obj.title = (i18next.t('account'));
            outColsArr[i] = obj;
          }else{
            obj.name = lmtOutStandingOrderColumnOrder[i];
            obj.title = (i18next.t(lmtOutStandingOrderColumnOrder[i]));
            outColsArr[i] = obj;
          }
        }
      } else {
        if(lmtOutStandingOrderColumnOrder[i] === "accDescription"){
          obj.name = lmtOutStandingOrderColumnOrder[i];
          obj.title = (i18next.t('account'));
          outColsArr[i] = obj;
        }else{
          obj.name = lmtOutStandingOrderColumnOrder[i];
          obj.title = (i18next.t(lmtOutStandingOrderColumnOrder[i]));
          outColsArr[i] = obj;
        }
      }
    }
    //  var colObj={"name":"action","title":""};
    // if(outColsArr.findIndex(x => x.name=="action") === -1){
    //   outColsArr.unshift(colObj);
    //   lmtOutStandingOrderColumnOrder.unshift('action');
    // }
    this.setState({outLmtColumnOrder:lmtOutStandingOrderColumnOrder});
    this.setState({outLmtOrdcolumns:outColsArr});

    for(let i=0 ; i< lmtAllOrdColumnOrder.length ; i++){
      var obj ={};
      if(lmtAllOrdColumnOrder[i] === "accDescription"){
        obj.name = lmtAllOrdColumnOrder[i];
        obj.title = (i18next.t('account'));
        allColsArr[i] = obj;
      }else{
         obj.name = lmtAllOrdColumnOrder[i];
        obj.title = (i18next.t(lmtAllOrdColumnOrder[i]));
        allColsArr[i] = obj;
      }

    }
    // var colObj={"name":"action","title":""};
    // if(allColsArr.findIndex(x => x.name=="action") === -1){
    //   allColsArr.unshift(colObj);
    //   lmtAllOrdColumnOrder.unshift('action');
    // }
    this.setState({allLmtOrderColumns:allColsArr});

    for(let i=0 ; i< lmtFillOrdColumnOrder.length ; i++){
      var obj ={};
      obj.name = lmtFillOrdColumnOrder[i];
      obj.title = (i18next.t(lmtFillOrdColumnOrder[i]));
      fillColsArr[i] = obj;
    }
    this.setState({filledLmtOrderColumns:fillColsArr});

    for(let i=0 ; i< lmtCancelledOrdColumnOrder.length ; i++){
      var obj ={};
      obj.name = lmtCancelledOrdColumnOrder[i];
      obj.title = (i18next.t(lmtCancelledOrdColumnOrder[i]));
      cancellColsArr[i] = obj;
    }
    this.setState({cancelledLmtOrderColumns:cancellColsArr});

    for(let i=0 ; i< lmtExpiedOrdColumnOrder.length ; i++){
      var obj ={};
      obj.name = lmtExpiedOrdColumnOrder[i];
      obj.title = (i18next.t(lmtExpiedOrdColumnOrder[i]));
      expColsArr[i] = obj;
    }
    this.setState({expiredLmtOrderColumns:expColsArr});
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    this.setState({outstngLmtOrderRows:this.props.limitOrdBook.outstandingLm.outstandingLmArr});
    this.setState({ordbookTableRowCount:this.props.limitOrdBook.outstandingLm.outstandingLmArr.length});
    this.setState({lmtOrderFilledrows:this.props.limitOrdBook.lmFillOrd.lmFillOrdArr});
    this.setState({lmtCancelledOrderRows:this.props.limitOrdBook.lmCancellOrd.lmCancellOrdArr});
    this.setState({lmtExpiredOrderRows:this.props.limitOrdBook.lmExpOrd.lmExpOrdArr});
    this.setState({allLmtOrdersRows:this.props.limitOrdBook.lmtOrdersRows});
    this.setState({lmtOutstandingRandomNo:this.props.limitOrdBook.outstandingLm.randomNo});
    this.setState({lmtFillRandomNo:this.props.limitOrdBook.lmFillOrd.randomNo});
    this.setState({lmtCancelledRandomNo:this.props.limitOrdBook.lmCancellOrd.randomNo});
    this.setState({lmtExpiredRandomNo:this.props.limitOrdBook.lmExpOrd.randomNo});
    this.setState({lmtRandomNo:this.props.limitOrdBook.randomNo});
    this.setState({CTID:this.props.ordersCTID});
    this.setState({refreshIconFlag:this.props.orderBookLoaderFlag});
    this.setState({hiddenOutLmtColumnNames :this.props.tradeBookColumns.hiddenLmtOutStandingOrderColumnNames});
    this.setState({hiddenAllLmtOrderColNames:this.props.tradeBookColumns.hiddenLmtOrderColumnNames});
    this.setState({hiddenFilledOrderColNames:this.props.tradeBookColumns.hiddenLmtFilledOrderColumnNames});
    this.setState({hiddenCancelledLmtOrderColNames:this.props.tradeBookColumns.hiddenLmtCancelledOrderColumnNames});
    this.setState({hiddenExpiredColumnNames:this.props.tradeBookColumns.hiddenLmtExpOrderColumnNames});
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName("dropdown-item")[0], "classNames":"dropdown-item"}
    ];
    //(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }
  // componentWillUpdate(nextProps, nextState) {
  //     const thisComponent = ReactDOM.findDOMNode(this);
  //     const allCssStyleRules = nextProps.selectedCssColorTheme;
  //     setTimeout(function(){
  //       applyStyle(thisComponent, allCssStyleRules, elementsData);
  //     },100);
  // }

  // componentDidUpdate(preProps){
  //   const thisComponent = ReactDOM.findDOMNode(this);
  //   //const allCssStyleRules = this.props.selectedCssColorTheme;
  //   applyStyle(thisComponent, allCssStyleRules, elementsData);
  // }

  componentWillReceiveProps(nextProps, nextState){
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    // }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
    if(nextProps.language !== this.props.language){
      let lmtOutStandingOrderColumnOrder = nextProps.tradeBookColumns.lmtOutStandingOrderColumnOrder;
      var outColsArr =[];
      for(let i=0 ; i< lmtOutStandingOrderColumnOrder.length ; i++){
        var obj ={};
        if(lmtOutStandingOrderColumnOrder[i] === "accDescription"){
          obj.name = lmtOutStandingOrderColumnOrder[i];
          obj.title = (i18next.t('account'));
          outColsArr[i] = obj;
        }else{
          obj.name = lmtOutStandingOrderColumnOrder[i];
          obj.title = (i18next.t(lmtOutStandingOrderColumnOrder[i]));
          outColsArr[i] = obj;
        }
      }
      this.setState({outLmtOrdcolumns:outColsArr});
      let lmtAllOrdColumnOrder = nextProps.tradeBookColumns.lmtOrderColumnOrder
      var allColsArr=[];
      for(let i=0 ; i< lmtAllOrdColumnOrder.length ; i++){
        var obj ={};
        if(lmtAllOrdColumnOrder[i] === "accDescription"){
          obj.name = lmtAllOrdColumnOrder[i];
          obj.title = (i18next.t('account'));
          allColsArr[i] = obj;
        }else{
          obj.name = lmtAllOrdColumnOrder[i];
          obj.title = (i18next.t(lmtAllOrdColumnOrder[i]));
          allColsArr[i] = obj;
        }
      }
      this.setState({allLmtOrderColumns:allColsArr});

      let lmtFillOrdColumnOrder = nextProps.tradeBookColumns.lmtFilledOrderColumnOrder;
      var fillColsArr =[];
      for(let i=0 ; i< lmtFillOrdColumnOrder.length ; i++){
        var obj ={};
        if(lmtFillOrdColumnOrder[i] === "accDescription"){
          obj.name = lmtFillOrdColumnOrder[i];
          obj.title = (i18next.t('account'));
          fillColsArr[i] = obj;
        }else{
          obj.name = lmtFillOrdColumnOrder[i];
          obj.title = (i18next.t(lmtFillOrdColumnOrder[i]));
          fillColsArr[i] = obj;
        }
      }
      this.setState({filledLmtOrderColumns:fillColsArr});

      let lmtExpiedOrdColumnOrder = nextProps.tradeBookColumns.lmtExpOrderColumnOrder;
      var expColsArr=[];
      for(let i=0 ; i< lmtExpiedOrdColumnOrder.length ; i++){
        var obj ={};
        if(lmtExpiedOrdColumnOrder[i] === "accDescription"){
          obj.name = lmtExpiedOrdColumnOrder[i];
          obj.title = (i18next.t('account'));
          expColsArr[i] = obj;
        }
        else{
        obj.name = lmtExpiedOrdColumnOrder[i];
        obj.title = (i18next.t(lmtExpiedOrdColumnOrder[i]));
        expColsArr[i] = obj;
      }
      }
      this.setState({expiredLmtOrderColumns:expColsArr});

      let lmtCancelledOrdColumnOrder = nextProps.tradeBookColumns.lmtCancelledOrderColumnOrder;
      var cancellColsArr=[];
      for(let i=0 ; i< lmtCancelledOrdColumnOrder.length ; i++){
        var obj ={};
        if(lmtCancelledOrdColumnOrder[i] === "accDescription"){
          obj.name = lmtCancelledOrdColumnOrder[i];
          obj.title = (i18next.t('account'));
          cancellColsArr[i] = obj;
        }else{
          obj.name = lmtCancelledOrdColumnOrder[i];
          obj.title = (i18next.t(lmtCancelledOrdColumnOrder[i]));
          cancellColsArr[i] = obj;
        }
      }
      this.setState({cancelledLmtOrderColumns:cancellColsArr});
    }
    if(nextProps.orderBookLoaderFlag !== this.props.orderBookLoaderFlag){
      this.setState({refreshIconFlag:nextProps.orderBookLoaderFlag});
    }

    if(this.props.requestRejectModal !== nextProps.requestRejectModal){
      if(nextProps.requestRejectModal.title !== "" && nextProps.requestRejectModal.OT !== 4){
        if(nextProps.requestRejectModal.bcm === '107' || nextProps.requestRejectModal.bcm === '106' ) {
          ordRectFlag=true;
        }
      }else if(this.props.requestRejectModal.mdflag !== nextProps.requestRejectModal.mdflag ){
        if(nextProps.requestRejectModal.mdflag === false){
          ordRectFlag=false;
        }

      }
    }
    if (nextProps.statusChanged.length>0 && this.state.multipleCancelModal === true) {
      let updateStatus=[];
      updateStatus= this.state.cancelModalrow;
      for (var i = 0; i < nextProps.statusChanged.length; i++) {
        for (var j = 0; j < updateStatus.length; j++) {
          if (nextProps.statusChanged[i].docNo === updateStatus[j].orderNo) {
            updateStatus[j].status_val = nextProps.statusChanged[i].status_val;
            updateStatus[j].reason = nextProps.statusChanged[i].reason;
          }
        }
      }
      this.setState({cancelModalrow:updateStatus});
      ordRectFlag=false;
    }

    if(nextProps.ordersRandomNoDB !== this.props.ordersRandomNoDB){
      var outObj=nextProps.limitOrdBook.outstandingLm.outstandingLmArr;
      var allObj=nextProps.limitOrdBook.lmtOrdersRows;
      var fillObj= nextProps.limitOrdBook.lmFillOrd.lmFillOrdArr;
      var cncelledObj= nextProps.limitOrdBook.lmCancellOrd.lmCancellOrdArr;
      var expiredObj= nextProps.limitOrdBook.lmExpOrd.lmExpOrdArr;
      var outLmtRows = [];
      var allLmtRows = [];
      var filledLmtRows = [];
      var cncelledLmtRows = [];
      var expiredLmtRows = [];
      this.setState({outstngLmtOrderRows:outLmtRows.concat(outObj)});
      this.setState({allLmtOrdersRows:allLmtRows.concat(allObj)});
      this.setState({lmtOrderFilledrows:filledLmtRows.concat(fillObj)});
      this.setState({lmtCancelledOrderRows:cncelledLmtRows.concat(cncelledObj)});
      this.setState({lmtExpiredOrderRows:expiredLmtRows.concat(expiredObj)});
      this.setState({selectLMT:this.state.selectLMT});
      this.setState({selectLMTKey:this.state.selectLMTKey});
      let ordbookTableRowCount=this.state.selectLMTKey === 'A' ? nextProps.limitOrdBook.lmtOrdersRows.length :
      this.state.selectLMTKey === 'O' ? nextProps.limitOrdBook.outstandingLm.outstandingLmArr.length :
      this.state.selectLMTKey === 'F' ? nextProps.limitOrdBook.lmFillOrd.lmFillOrdArr.length :
      this.state.selectLMTKey === 'C' ? nextProps.limitOrdBook.lmCancellOrd.lmCancellOrdArr.length :
      nextProps.limitOrdBook.lmExpOrd.lmExpOrdArr.length;
      this.setState({ordbookTableRowCount:ordbookTableRowCount});
      this.props.orderRefreshFlag(false);
    }

    //outstanding LimitOrder
    if(nextProps.limitOrdBook.outstandingLm.outstandingLmArr.length === 0){
      this.setState({outstngLmtOrderRows:nextProps.limitOrdBook.outstandingLm.outstandingLmArr});
    }
    if (nextProps.limitOrdBook.outstandingLm.randomNo !== this.state.lmtOutstandingRandomNo) {
      var outstngLmtOrderRows = [];
      var obj=nextProps.limitOrdBook.outstandingLm.outstandingLmArr;
      this.setState({outstngLmtOrderRows:outstngLmtOrderRows.concat(obj)});
      this.setState({lmtOutstandingRandomNo:nextProps.limitOrdBook.outstandingLm.randomNo});
      this.props.orderRefreshFlag(false);
      this.setState({selectLMT:i18next.t("outstanding")});
      this.setState({selectLMTKey:'O'});
      this.setState({ordbookTableRowCount:nextProps.limitOrdBook.outstandingLm.outstandingLmArr.length});
      var allLmtOrdersRows = [];
      var obj='';
      obj=nextProps.limitOrdBook.lmtOrdersRows;
      this.setState({allLmtOrdersRows:allLmtOrdersRows.concat(obj)});
    }

    //filled Limit order
  //  if(this.state.lmtOrderFilledrows.length !== nextProps.limitOrdBook.lmFillOrd.lmFillOrdArr.length){
      if (nextProps.limitOrdBook.lmFillOrd.randomNo !== this.state.lmtFillRandomNo){
        var lmtOrderFilledrows = [];
        var obj=nextProps.limitOrdBook.lmFillOrd.lmFillOrdArr;
        this.setState({lmtOrderFilledrows:lmtOrderFilledrows.concat(obj)});
        this.setState({lmtFillRandomNo:nextProps.limitOrdBook.lmFillOrd.randomNo});
        this.props.orderRefreshFlag(false);
        this.setState({selectLMT:i18next.t("filled")});
        this.setState({selectLMTKey:'F'});
        this.setState({ordbookTableRowCount:nextProps.limitOrdBook.lmFillOrd.lmFillOrdArr.length});
        var allLmtOrdersRows = [];
        var obj='';
        obj=nextProps.limitOrdBook.lmtOrdersRows;
        this.setState({allLmtOrdersRows:allLmtOrdersRows.concat(obj)});
      }
    //}

    //cancelledLimit
    if(this.state.lmtCancelledOrderRows.length !== nextProps.limitOrdBook.lmCancellOrd.lmCancellOrdArr.length){
      if ( nextProps.limitOrdBook.lmCancellOrd.randomNo !== this.state.lmtCancelledRandomNo) {
        var lmtCancelledOrderRows = [];
        var obj=nextProps.limitOrdBook.lmCancellOrd.lmCancellOrdArr;
        this.setState({lmtCancelledOrderRows:lmtCancelledOrderRows.concat(obj)});
        this.setState({lmtCancelledRandomNo:nextProps.limitOrdBook.lmCancellOrd.randomNo});
        var outstngLmtOrderRows = [];
        var obj=nextProps.limitOrdBook.outstandingLm.outstandingLmArr;
        this.setState({outstngLmtOrderRows:outstngLmtOrderRows.concat(obj)});
        this.props.orderRefreshFlag(false);
        this.setState({selectLMT:i18next.t("cancelled")});
        this.setState({selectLMTKey:'C'});
        this.setState({ordbookTableRowCount:nextProps.limitOrdBook.lmCancellOrd.lmCancellOrdArr.length});
        var allLmtOrdersRows = [];
        var obj='';
        obj=nextProps.limitOrdBook.lmtOrdersRows;
        this.setState({allLmtOrdersRows:allLmtOrdersRows.concat(obj)});
      }
    }

    //Expired
    if(this.state.lmtExpiredOrderRows.length !== nextProps.limitOrdBook.lmExpOrd.lmExpOrdArr.length){
      if ( nextProps.limitOrdBook.lmExpOrd.randomNo !== this.state.lmtExpiredRandomNo) {
        var lmtExpiredOrderRows = [];
        var obj=nextProps.limitOrdBook.lmExpOrd.lmExpOrdArr;
        this.setState({lmtExpiredOrderRows:lmtExpiredOrderRows.concat(obj)});
        this.setState({lmtExpiredRandomNo:nextProps.limitOrdBook.lmExpOrd.randomNo});
        var outstngLmtOrderRows = [];
        var obj1=nextProps.limitOrdBook.outstandingLm.outstandingLmArr;
        this.setState({outstngLmtOrderRows:outstngLmtOrderRows.concat(obj1)});
        this.props.orderRefreshFlag(false);
        this.setState({selectLMT:i18next.t("expired")});
        this.setState({selectLMTKey:'E'});
        this.setState({ordbookTableRowCount:nextProps.limitOrdBook.lmExpOrd.lmExpOrdArr.length});
        var allLmtOrdersRows = [];
        var obj2=nextProps.limitOrdBook.lmtOrdersRows;
        this.setState({allLmtOrdersRows:allLmtOrdersRows.concat(obj2)});
      }
    }

    //All LMT
    // if(this.state.allLmtOrdersRows.length!== nextProps.limitOrdBook.lmtOrdersRows.length){
    //   if(nextProps.limitOrdBook.randomNo !== this.state.lmtRandomNo){
    //       var allLmtOrdersRows =[];
    //       var obj='';
    //       obj=nextProps.limitOrdBook.lmtOrdersRows;
    //       this.setState({allLmtOrdersRows:allLmtOrdersRows.concat(obj)});
    //       this.setState({lmtRandomNo:nextProps.limitOrdBook.randomNo});
    //       this.setState({ordbookTableRowCount:nextProps.limitOrdBook.lmtOrdersRows.length});
    //       this.props.orderRefreshFlag(false);
    //   }
    // }

    if(nextProps.lmtModifyFlag !== this.props.lmtModifyFlag){
      if(nextProps.lmtModifyFlag === false){
        this.setState({enableLimitModifyFlag:false});
        this.setState({orderSelection:[]});
      }
    }
    if(this.state.CTID !== nextProps.ordersCTID){
      this.setState({CTID:nextProps.ordersCTID});
    };
    if(nextProps.navigationStatus !== this.props.navigationStatus){
      this.setState({selectedRowOrderNo:''});
    }
  }

  //outLmt
  onChangeOutLmtColOrder(newOrder) {
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.lmtOutStandingOrderColumnOrder=newOrder;
      this.setState({ outLmtColumnOrder:newOrder });
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeOutLmtColOrder', component:"LimitOrderTableComponent"});
    }
  }

  onChangeOutLmtColSorting(sorting) {
    try{
      this.setState({outLmtColsSorting:sorting});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeOutLmtColSorting', component:"LimitOrderTableComponent"});
    }
  }

  onChangeHiddenOutLmtCol(hiddenOutLmtColumnNames){
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.hiddenLmtOutStandingOrderColumnNames=hiddenOutLmtColumnNames;
      this.setState({hiddenOutLmtColumnNames:hiddenOutLmtColumnNames});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenOutLmtCol', component:"LimitOrderTableComponent"});
    }
  };

  onChangeOutLmtSearchValue(value){
    try{
      this.setState({outLmtSearchValue:value });
      var count=getCountofTableRows(this.state.outstngLmtOrderRows, this.props.tradeBookColumns.lmtOutStandingOrderColumnOrder, value);
      this.setState({ordbookTableRowCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeOutLmtSearchValue', component:"LimitOrderTableComponent"});
    }
  }

  //allLmtOrder
  onChangeAllLmtColOrder(newOrder) {
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.lmtOrderColumnOrder=newOrder;
      this.setState({allLmtColumnOrder:newOrder});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeAllLmtColOrder', component:"LimitOrderTableComponent"});
    }
  }

  onChangeAllLmtColSorting(sorting) {
    try{
      this.setState({ outLmtColsSorting:sorting });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeAllLmtColSorting', component:"LimitOrderTableComponent"});
    }
  }

  onChangeHiddenAllLmtCol(hiddenCol){
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.hiddenLmtOrderColumnNames=hiddenCol;
      this.setState({ hiddenAllLmtOrderColNames:hiddenCol});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenAllLmtCol', component:"LimitOrderTableComponent"});
    }
  };

  onChangeAllLmtSearchValue(value){
    try{
      this.setState({allLmtSearchValue:value });
      var count=getCountofTableRows(this.state.allLmtOrdersRows, this.props.tradeBookColumns.lmtOrderColumnOrder, value);
      this.setState({ordbookTableRowCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeAllLmtSearchValue', component:"LimitOrderTableComponent"});
    }
  }

  //FILLED
  onChangeFilledLmtColOrder(newOrder) {
    try{
      this.setState({ filledLmtColOrder:newOrder });
      let trdCols =this.props.tradeBookColumns;
      trdCols.lmtFilledOrderColumnOrder=newOrder;
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeFilledLmtColOrder', component:"LimitOrderTableComponent"});
    }
  }

  onChangeFillColSorting(sorting) {
    try{
      this.setState({ filledLmtColsSorting:sorting });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeFillColSorting', component:"LimitOrderTableComponent"});
    }
  }

  onChangeHiddenFilledCol(hiddenCol){
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.hiddenLmtFilledOrderColumnNames=hiddenCol;
      this.setState({ hiddenFilledOrderColNames:hiddenCol});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenFilledCol', component:"LimitOrderTableComponent"});
    }
  };

  onChangeFilledSearchValue(value){
    try{
      this.setState({filledLmtSearchValue:value });
      var count=getCountofTableRows(this.state.lmtOrderFilledrows, this.props.tradeBookColumns.lmtFilledOrderColumnOrder, value);
      this.setState({ordbookTableRowCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeFilledSearchValue', component:"LimitOrderTableComponent"});
    }
  }

  //Cancelled
  onChangeCancelColOrder(newOrder) {
    try{
      this.setState({ cancelledLmtColOrder:newOrder });
      let trdCols =this.props.tradeBookColumns;
      trdCols.lmtCancelledOrderColumnOrder=newOrder;
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelColOrder', component:"LimitOrderTableComponent"});
    }
  }

  onChangeCancelColSorting(sorting) {
    try{
      this.setState({ cancelledLmtColsSorting:sorting });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelColSorting', component:"LimitOrderTableComponent"});
    }
  }

  onChangeHiddenCancelCol(hiddenCol){
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.hiddenLmtCancelledOrderColumnNames=hiddenCol;
      this.setState({ hiddenCancelledLmtOrderColNames:hiddenCol});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenCancelCol', component:"LimitOrderTableComponent"});
    }
  };

  onChangeCancelSearchValue(value){
    try{
      this.setState({cancelledLmtSearchValue:value });
      var count=getCountofTableRows(this.state.lmtCancelledOrderRows, this.props.tradeBookColumns.lmtCancelledOrderColumnOrder, value);
      this.setState({ordbookTableRowCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelSearchValue', component:"LimitOrderTableComponent"});
    }
  }

  //EXPIRED
  onChangeExpiredColOrder(newOrder) {
    try{
      this.setState({ expiredLmtColOrder:newOrder });
      let trdCols =this.props.tradeBookColumns;
      trdCols.lmtExpOrderColumnOrder=newOrder;
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeExpiredColOrder', component:"LimitOrderTableComponent"});
    }
  }

  onChangeExpiredColSorting(sorting) {
    try{
      this.setState({ expiredLmtColsSorting:sorting });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeExpiredColSorting', component:"LimitOrderTableComponent"});
    }
  }

  onChangeHiddenExpiredCol(hiddenCol){
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.hiddenLmtExpOrderColumnNames=hiddenCol;
      this.setState({ hiddenExpiredColumnNames:hiddenCol});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenExpiredCol', component:"LimitOrderTableComponent"});
    }
  };

  onChangeExpiredSearchValue(value){
    try{
      this.setState({expiedLmtSearchValue:value });
      var count=getCountofTableRows(this.state.lmtExpiredOrderRows, this.props.tradeBookColumns.lmtExpOrderColumnOrder, value);
      this.setState({ordbookTableRowCount:count});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeExpiredSearchValue', component:"LimitOrderTableComponent"});
    }
  }

  onChangeCancelModalSortiog(sorting){
    try{
      this.setState({cancelModalSorting:sorting });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelModalSortiog', component:"LimitOrderTableComponent"});
    }
  }

  onChangeCancelModalColOrder(order){
    try{
      this.setState({cancelModalColOrder:order});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelModalColOrder', component:"LimitOrderTableComponent"});
    }
  }

  onChangeCancelModalSearchValue(value){
    try{
      this.setState({cancelModalSearchValue:value });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeCancelModalSearchValue', component:"LimitOrderTableComponent"});
    }
  }

  editLimitOrdModal = (event) => {
    try{
      let showPrice = this.props.userDetail.showPrice == "BID" ? 'SELL' : this.props.userDetail.showPrice === "ASK" ? 'BUY' : 'BOTH';
      let deal = '';
      if(this.state.orderSelection.length){
        deal = this.state.orderSelection[0].deal === "STOP BUY" ? "BUY" : this.state.orderSelection[0].deal === "STOP SELL" ? "SELL" : this.state.orderSelection[0].deal;
      }
      let showPriceValMsg = this.props.userDetail.showPrice == "BID" ? 'BUY' : this.props.userDetail.showPrice === "ASK" ? 'SELL' : 'BOTH';
      const orderAcc = getAccountByCode(this.props.ACD, this.state.orderSelection[0]?.accCode)
      if(parseInt(this.props.status) !== 0){
        this.setState({statusFlag:true});
      } else if(this.state.orderSelection.length === undefined || this.state.orderSelection.length === 0 && parseInt(this.props.status) === 0){
        this.setState({disableModifyFlag:true});
        this.setState({lmtEditErrMsgHeader:"modifyOrds"});
        this.setState({lmtEditErrMsg:"selectOrdModifyMsg"});
      } else if(this.state.orderSelection.length > 1 && parseInt(this.props.status) === 0){
          this.setState({disableModifyFlag:true});
          this.setState({lmtEditErrMsgHeader:"Modify Order"});
          this.setState({lmtEditErrMsg:"Please select only one order to modify"});
      } else if(deal !== showPrice && this.props.userDetail.showPrice!=='BOTH'){
          this.setState({disableModifyFlag:true});
          this.setState({lmtEditErrMsgHeader:"Modify Order"});
          this.setState({lmtEditErrMsg:showPriceValMsg+" price disabled for your account. Please contact the Trading Desk in order to amend this order."});
      } else if(!Number(orderAcc.isActiveAcc)) {
          this.setState({disableModifyFlag:true});
          this.setState({lmtEditErrMsgHeader:"Modify Order"});
          this.setState({lmtEditErrMsg:displayInActiveAccMsg(orderAcc.D,orderAcc.C)});
      } else {
        // this.setState({lmtordNo:this.state.selectedRowOrderNo});
        this.setState({LMTModel:true});
        this.props.closeLmtModifypopup(true);
        //let parFillFlg=false;
        // for (var i = 0; i < this.state.outstngLmtOrderRows.length; i++) {
        //   this.state.outstngLmtOrderRows[i].selected= false;
        //   this.state.selectLMTOrds[this.state.outstngLmtOrderRows[i].orderNo]=false;
        //   if(this.state.outstngLmtOrderRows[i].orderNo===lmtOrderArray[0]){
        //     if(parseFloat(this.state.outstngLmtOrderRows[i].filled)>0)
        //     {
        //         parFillFlg=true;
        //     }
        //   }
        // }
        // if(parFillFlg=== true){
        //   this.setState({disableModifyFlag:true});
        //   this.setState({lmtEditErrMsgHeader:"Modify Order"});
        //   this.setState({lmtEditErrMsg:"Partially filled order cannot modified."});
        // }
        // if(parFillFlg !== true){
        //   this.setState({enableLimitModifyFlag:true});
        //   this.props.handleLimitModal(true);
        // }
        this.setState({enableLimitModifyFlag:true});
        this.props.handleLimitModal(true);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'editLimitOrdModal', component:"LimitOrderTableComponent"});
    }
  }

  //onclick cancelled order to open modal
  cancelLmtOrdModal = (event) => {
    try{
      const orderAcc = getAccountByCode(this.props.ACD, this.state.orderSelection[0]?.accCode)
      const inactiveAccounts = getInactiveAccounts(this.state.orderSelection, this.props.ACD);
      this.setState({stopBtnReplaceflag:false});
        if(parseInt(this.props.status) !== 0){
        this.setState({statusFlag:true});
      }
      if(this.state.orderSelection.length === undefined || this.state.orderSelection.length === 0 && parseInt(this.props.status) === 0){
        this.setState({disableModifyFlag:true});
        this.setState({lmtEditErrMsgHeader:"cancelOrd"});
        this.setState({lmtEditErrMsg:"selectOrdCancelMsg"});
        return
      }
      if(this.state.orderSelection.length > 1 && inactiveAccounts.length) {
        this.setState({cancelAllDisableModal:true});
        this.setState({lmtEditErrMsgHeader:"cancelOrd"});
        this.setState({lmtEditErrMsg:`followingAccountsInactive`});
        this.setState({inactiveAccOnOrders: inactiveAccounts})
        return
      }
      if(!Number(orderAcc.isActiveAcc)) {
        this.setState({disableModifyFlag:true});
        this.setState({lmtEditErrMsgHeader:"cancelOrd"});
        this.setState({lmtEditErrMsg:displayInActiveAccMsg(orderAcc.D,orderAcc.C)});
        return
      }
      if(this.state.orderSelection.length === 1 && parseInt(this.props.status) === 0){
        this.setState({cancelLMTModel:true});
        this.props.orderSelectionFunc(true);
      }
      if(this.state.orderSelection.length >1 && parseInt(this.props.status) === 0){
        this.setState({cancelLMTModel:true});
        this.props.orderSelectionFunc(false);
        this.setState({selectedOrderNo:''});

        this.setState({selectedDocNo:''});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelLmtOrdModal', component:"LimitOrderTableComponent"});
    }
  }

  getWsDataCancelord =(order, OMT,PCT,OT)=>{
    try{
      const user = JSON.parse(localStorage.getItem('user'));
      const AccDet=JSON.parse(localStorage.getItem('DefaultAC'));
      if (user === null) {
        dispatch(sessionTimeout());
      }
      const platform = localStorage.getItem('platform');
      var obj={};
      var arr=[];

       obj.language=navigator.language;
       obj.platform=platform;
       obj.browser=navigator.userAgent
       obj.SID=user.SID;
       obj.UID=user.UID;
       obj.UCD=user.trdCode;
       obj.UD=user.UD;
       obj.OMT=OMT;
       obj.CID=user.location;
       obj.PCT=PCT;
       obj.AC=order.accCode,
       obj.AD=order.accDescription,
       obj.NOD=order.orderNo,
       obj.R=unformatLang(order.OR),
       obj.PQ=unformatLang(order.quantity),
       obj.GQ=order.quantity,
       obj.RMK=order.comments,
       obj.SC=order.OSC, //this is only for metals, for forex this will be blank
       obj.IID=order.cmdtyId,
       obj.BID=order.BID ,//check if this is needed in new system, can be managed in server
       obj.DT=order.DT
       obj.VT=order.VT ,//validity, ValidityType class
       obj.HSE=1,
       obj.OT=OT, //In future stop orders might come, so OT inside array
       obj.PCLD=order.id,
       obj.MD=-1;
       obj.CTID=order.CTID,
       obj.MT="CANCEL_ORDER";
       return obj
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getWsDataCancelord', component:"LimitOrderTableComponent"});
    }
  }

  @track((props, state) => ({ 
    widgetDetails: { originFunction: "cancelLIMITOrder", event: appConstants.trackingEvents.CANCEL_ORDER},
    ordDetails: [wsData]
  }))

  //single cancel
  cancelLIMITOrder = (lmtArrayList) => {
    try{
      if(this.state.orderSelection.length ===1 && parseInt(this.props.status) === 0){
        let index1;
        var orderDetailsArray=[];
        var OMT = 6;
        var PCT = 4;
        var DT;
        let cmdtyId;
        var orderDetails;
        lmtArrayList.map((item) => {
          orderDetails=this.props.limitOrdBook.limitOrdMap.get(item.orderNo);
          var DealTypeBM = orderDetails.deal;
          var socketDataMap = this.props.socketData.get(orderDetails.cmdtyId);
          if (DealTypeBM.toUpperCase() === config.buy) {
            let price = socketDataMap.MA;
            DT = 1;
          } else {
            let price = socketDataMap.MB;
            DT = 0;
          }
          let com=socketDataMap.B;
          var valueDate = socketDataMap.VD;
          if(com===1)
          {
            orderDetails.OSC="";
          }
          orderDetailsArray.push(orderDetails);
        });
        this.setState({selectedOrderNo:orderDetails.orderNo});
        this.setState({selectedDocNo:orderDetails.orderNo});
        this.setState({lmtOrdersRows:this.state.lmtOrdersRows});
        this.setState({outstngLmtOrderRows:this.state.outstngLmtOrderRows});
        this.setState({cancelModalrow:this.state.cancelModalrow});
        this.setState({cancelLMTModel:false});
        let processedData={
          OMT:OMT,
          PCT:PCT,
          AC:orderDetails.accCode,
          AD:orderDetails.accDescription,
          NOD:orderDetails.orderDetailsNo,
          R:orderDetails.OR,
          PQ:orderDetails.quantity,
          GQ:orderDetails.quantity,
          RMK:orderDetails.comments,
          SC:orderDetails.OSC,
          IID:orderDetails.cmdtyId,
          BID:orderDetails.BID ,
          DT:orderDetails.DT ,
          VT:orderDetails.VT ,
          OT:orderDetails.orderType,
          PCLD:orderDetails.id,
          CTID:orderDetails.CTID,
          MT:"CANCEL_ORDER",
          language:navigator.language,
          platform: localStorage.getItem('platform'),
          browser:navigator.userAgent
        }
        this.setState({processedData})
        this.props.handleCancelledLMT(orderDetails,OMT,PCT,orderDetails.orderType);
        wsData=this.getWsDataCancelord(orderDetails,OMT,PCT,orderDetails.orderType)
        let apiValidateData=[{processedData},{wsData}]
        this.props.validateOrder(JSON.stringify(apiValidateData))
        this.setState({orderSelection:[]});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelLIMITOrder', component:"LimitOrderTableComponent"});
    }
  }

  
  multipleCancelLIMITOrder = (lmtArrayList) => {
    try{
      if(this.state.orderSelection.length > 1 && parseInt(this.props.status) === 0){
        var OMT=6;
        let cancelArraymodal=[];
        if(this.state.selectLMTKey==="O"){
          this.state.orderSelection.map((order)=>{
            var obj={
              'orderNo':order.orderNo,
              'deal':order.deal,
              'cmdtyPair':order.cmdtyPair,
              'quantity':order.quantity,
              'qtyType':order.qtyType,
              'price':order.price,
              'status_val':"Pending",
              'reason':"",
            }
            cancelArraymodal.push(obj);
          });
        } else if(this.state.selectLMTKey==="A"){
          this.state.orderSelection.map((order)=>{
            var obj={
              'orderNo':order.orderNo,
              'deal':order.deal,
              'cmdtyPair':order.pair,
              'quantity':order.quantity,
              'qtyType':order.qtyType,
              'price':order.rate,
              'status_val':"Pending",
              'reason':"",
            }
            cancelArraymodal.push(obj);
          });
        }
        this.setState({cancelModalrow:cancelArraymodal});
        this.setState({multipleCancelModal:true});
        for (let i=0; i<cancelArraymodal.length; i++){
          setTimeout(()=>{
            selectedRowsToCancel[i].status_val="In Progress";
            if(this.state.stopBtnReplaceflag===true){
              for (var j = 0; j < cancelArraymodal.length; j++) {
                if(cancelArraymodal[j].status_val==="Pending"){
                  cancelArraymodal[j].status_val="Stopped";
                  selectedRowsToCancel[j].status_val="Stopped";
                }
              }
              this.setState({cancelModalrow:cancelArraymodal});
            } else {
              if(cancelArraymodal[i].status_val==="Pending"){
                cancelArraymodal[i].status_val="In Progress";
                selectedRowsToCancel[i].status_val="In Progress";
              }
            }
          },i*2000);
          setTimeout(()=>{
            if(cancelArraymodal[i].status_val==="In Progress"){
              this.cancelMultipleLMTOrder(selectedRowsToCancel[i],i);
              ordRectFlag=false;
            }
          },i*3000);
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'multipleCancelLIMITOrder', component:"LimitOrderTableComponent"});
    }
  }

  @track((props, state) => ({ 
    widgetDetails: { originFunction: "cancelMultipleLMTOrder", event: appConstants.trackingEvents.CANCEL_ORDER},
    ordDetails: [wsData]
  }))

  //Multiple cancelLMTOrder
  cancelMultipleLMTOrder = (lmtArrayList,index) => {
    try{
      let index1;
      var orderDetailsArray=[];
      var OMT = 6;
      var PCT = 4;
      var DT;
      let cmdtyId;
      var orderDetails;
      orderDetails=this.props.limitOrdBook.limitOrdMap.get(lmtArrayList.orderNo);
      var DealTypeBM = orderDetails.deal;
      var socketDataMap = this.props.socketData.get(orderDetails.cmdtyId);
      if (DealTypeBM.toUpperCase() === config.buy) {
        let price = socketDataMap.MA;
        DT = 1;
      } else {
        let price = socketDataMap.MB;
        DT = 0;
      }
      let com=socketDataMap.B;
      var valueDate = socketDataMap.VD;
      if(com===1) {
        orderDetails.OSC="";
      }
      orderDetailsArray.push(orderDetails);
      this.setState({lmtOrdersRows:this.state.lmtOrdersRows});
      this.setState({outstngLmtOrderRows:this.state.outstngLmtOrderRows});
      this.setState({cancelLMTModel:false});
      for(let i=0; i< orderDetailsArray.length; i++){
        let processedData={
          OMT:OMT,
          PCT:PCT,
          AC:orderDetailsArray[i].accCode,
          AD:orderDetailsArray[i].accDescription,
          NOD:orderDetailsArray[i].orderDetailsNo,
          R:orderDetailsArray[i].OR,
          PQ:orderDetailsArray[i].quantity,
          GQ:orderDetailsArray[i].quantity,
          RMK:orderDetailsArray[i].comments,
          SC:orderDetailsArray[i].OSC,
          IID:orderDetailsArray[i].cmdtyId,
          BID:orderDetailsArray[i].BID ,
          DT:orderDetailsArray[i].DT ,
          VT:orderDetailsArray[i].VT ,
          OT:orderDetailsArray[i].orderType,
          PCLD:orderDetailsArray[i].id,
          CTID:orderDetailsArray[i].CTID,
          MT:"CANCEL_ORDER",
          language:navigator.language,
          platform:localStorage.getItem('platform'),
          browser:navigator.userAgent
        }
        this.props.handleCancelledLMT(orderDetailsArray[i],OMT,PCT,orderDetailsArray[i].orderType);
        wsData=this.getWsDataCancelord(orderDetailsArray[i],OMT,PCT,orderDetailsArray[i].orderType)
        let apiValidateData=[{processedData},{wsData}]
        this.props.validateOrder(JSON.stringify(apiValidateData))
        if (index == this.state.cancelModalrow.length-1) {
          this.setState({stopBtnReplaceflag:true});
        }
      }
      this.setState({orderSelection:[]});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelMultipleLMTOrder', component:"LimitOrderTableComponent"});
    }
  }

  stopBtnclick=(event)=>{
    try{
      this.setState({stopBtnReplaceflag:true});
      this.setState({orderSelection:[]});
      this.setState({cancelModalSearchValue:''});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'stopBtnclick', component:"LimitOrderTableComponent"});
    }
  }

  closeBtnclick=(event)=>{
    try{
      this.setState({stopBtnReplaceflag:false});
      this.setState({multipleCancelModal:false});
      this.setState({orderSelection:[]});
      this.setState({cancelModalSearchValue:''});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeBtnclick', component:"LimitOrderTableComponent"});
    }
  }

  //close modify limit ord modal
  closeLimitOrdpopup = (event) => {
    try{
      this.setState({selectedRowOrderNo:''});
      this.setState({LMTModel:false});
      this.props.closeLmtModifypopup(false);
      this.setState({enableLimitModifyFlag:false});
      this.props.handleLimitModal(false);
      this.setState({selectedOrderNo:''});
      this.setState({selectedDocNo:''});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeLimitOrdpopup', component:"LimitOrderTableComponent"});
    }
  }

  refreshComponentData =()=>{
    try{
      this.props.orderRefreshFlag(true);
      this.props.getOrderBook();
      this.setState({selectLMT:this.state.selectLMT});
      this.setState({selectLMTKey:this.state.selectLMTKey});
      this.setState({selectedRowOrderNo:''});
      this.setState({outLmtSearchValue:''});
      this.setState({allLmtSearchValue:''});
      this.setState({filledLmtSearchValue:''});
      this.setState({cancelledLmtSearchValue:''});
      this.setState({expiedLmtSearchValue:''});
      this.setState({cancelModalSearchValue:''});
      this.setState({selectedOrderNo:''});
      this.setState({selectedDocNo:''});
      this.setState({orderSelection:[]});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'refreshComponentData', component:"LimitOrderTableComponent"});
    }
  }

  selectLMT = (text,value) => {
    try{
      this.setState({selectLMT:text});
      this.setState({selectLMTKey:value});
      let ordbookTableRowCount=value === 'A' ? this.state.allLmtOrdersRows.length :
      value === 'O' ? this.state.outstngLmtOrderRows.length :
      value === 'F' ? this.state.lmtOrderFilledrows.length :
      value === 'C' ? this.state.lmtCancelledOrderRows.length :
      this.state.lmtExpiredOrderRows.length;
      this.setState({ordbookTableRowCount:ordbookTableRowCount});
      this.setState({selectedRowOrderNo:''});
      this.setState({selectedOrderNo:''});
      this.setState({selectedDocNo:''});
      this.setState({orderSelection:[]});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectLMT', component:"LimitOrderTableComponent"});
    }
  }

  closeReqRejectModal =()=>{
    try{
      this.setState({outstngLmtOrderRows:this.state.outstngLmtOrderRows});
      this.setState({lmtOrdersRows:this.state.lmtOrdersRows});
      ordRectFlag=false;
      this.props.closeReqRejectModal(this.props.requestRejectModal);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeReqRejectModal', component:"LimitOrderTableComponent"});
    }
  }

  cancelStatusModal = (event) => {
    try{
      this.setState({statusFlag:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelStatusModal', component:"LimitOrderTableComponent"});
    }
  }

  cancelLmtCnfrmBox = (event) => {
    try{
      this.setState({cancelLMTModel:false});
      this.setState({orderSelection:[]});
      this.setState({selectedOrderNo:''});
      this.setState({selectedDocNo:''});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelLmtCnfrmBox', component:"LimitOrderTableComponent"});
    }
  }

  cancelMultiCancelModal =(event) =>{
    try{
      this.setState({checkMultiCnclStatusMdl:false});
      this.setState({stopBtnReplaceflag:false});
      this.setState({orderSelection:[]});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelMultiCancelModal', component:"LimitOrderTableComponent"});
    }
  }

  closeMultipleCancelModal= (event) => {
    try{
      this.setState({stopBtnReplaceflag:true});
      this.setState({multipleCancelModal:false});
      this.setState({orderSelection:[]});
      this.setState({cancelModalSearchValue:''});
      // checkStatus.map((item)=>{
      //   if(item.status === "In Progress"){
      //     this.setState({multipleCancelModal:true});
      //     this.setState({checkMultiCnclStatusMdl:true});
      //   }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeMultipleCancelModal', component:"LimitOrderTableComponent"});
    }
  }

  //Close errorMsg Modal
  cancelDisableModifyModal = (event) => {
    try{
      this.setState({disableModifyFlag:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cancelDisableModifyModal', component:"LimitOrderTableComponent"});
    }
  }

  closeCancelAllDisableModal = (event) => {
    try {
      this.setState({cancelAllDisableModal: false, inactiveAccOnOrders: []})
    } catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeCancelAllDisableModal', component:"LimitOrderTableComponent"});
    }
  }

  changeOutColSelection=(selection)=>{
    try{
      this.setState({orderSelection:selection});
      selectedRowsToCancel = selection;
      if (selection.length>0) {
        this.setState({selectedOrderNo:selection[0].orderNo});
      }
      this.setState({selectedRowsData:this.state.outstngLmtOrderRows.filter(
        row => selection.findIndex(selectId => selectId === getRowId(row)) !== -1
      )});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeOutColSelection', component:"LimitOrderTableComponent"});
    }
  }

  changeAllColSelection=(selection)=>{
    try{
      this.setState({orderSelection:selection});
      selectedRowsToCancel = selection;
      if (selection.length>0) {
        this.setState({selectedDocNo:selection[0].orderNo});
      }
      this.setState({selectedRowsData:this.state.allLmtOrdersRows.filter(
        row => selection.findIndex(selectId => selectId === getRowId(row)) !== -1
      )});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeAllColSelection', component:"LimitOrderTableComponent"});
    }
  }

  generateInvoice=(row)=>{
    try{
      var docNo=row.toString().split('""');
      var getdocType = row.toString().split('/');
      var docType=getdocType[0];
      if(docType !== 'PFC'){
        this.props.getInvoice(docNo,docType);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'generateInvoice', component:"LimitOrderTableComponent"});
    }
  }

  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      // //const allCssStyleRules = this.props.selectedCssColorTheme;
      // const elementsData = [
      //   {"classNames":"errorheader", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"msgWrap", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"mdlWrap", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      //   {"classNames":"lmtClose","elementType":"normal", "applyTo":"all", "tagNames":"button"},
      //   {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"form-control","elementType":"tag", "applyTo":"all", "tagNames":"input"},
      //   {"classNames":"oi-eye","elementType":"tag", "applyTo":"all", "tagNames":"span"},
      // ];

      // applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {"classNames":"errorheader", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"modalCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"lmtClose","elementType":"normal", "applyTo":"all", "tagNames":"button"},
        {"classNames":"cancelRowTblDiv", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"cancelConfrmBtn", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      ];

      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
          {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
          {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"},
          {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[1], "classNames":"lmtClose"}
          //{"elmToHover":thisComponent.getElementsByClassName('dropDownList')[0], "classNames":"dropDownList"}
      ];

      //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"LimitOrderTableComponent"});
    }
  }

  render() {
    //hide column Name
    const TableHeaderContent = ({ column, children}) => (
      <TableHeaderRow.Content>
        {column.name !== 'action' ?
        (<span>{children} </span>) : null}
      </TableHeaderRow.Content>
    );

    const FillOrdersCell = props => {
      const { column } = props;
      if (column.name === "docNo") {
        return <InvoiceHighlightedCell {...props} />;
      }
      if(column.name === "eventTime"){
        return <Table.Cell {...props} className="eventTimeCell"/>;
      }
      return <Table.Cell {...props} />;
    };

    //AlL orders
    const AllOrdersCell = props => {
      const { column } = props;
      let cnt =0;
      if (column.name === "action" ) {
        return <CellWithRadioBtn {...props} />;
      }
      if (column.name === "docNo") {
        return <InvoiceHighlightedCell {...props} />;
      }
      if(column.name === "eventTime"){
        return <Table.Cell {...props} className="eventTimeCell"/>;
      }
      return <Table.Cell {...props} />;
    };

    const Cell = props => {
      const { column } = props;
      if(column.name === "eventTime"){
        return <Table.Cell {...props} className="eventTimeCell"/>;
      }
      return <Table.Cell {...props} />;
    };

    const CellWithRadioBtn = (props) => {
      return (
        <Table.Cell>
          {props.tableRow.row.status === 'Outstanding' ?
            <input
              type="radio"
              name="radioBtn"
              value={this.state.selectedRowOrderNo}
              onChange={()=>this.changeOutColSelection(props)}
              checked={this.state.selectedRowOrderNo === props.tableRow.row.orderNo}
            />
          : null}
        </Table.Cell>
      );
    }

    const InvoiceHighlightedCell = ({ value, style }) => (
      <Table.Cell>
        <span>
          {value.indexOf('PFC') === -1 ?
            <a className='trdeBookCell' title={i18next.t("invoiceDownldMsg")} onClick={()=>this.generateInvoice(value)}>{value}</a>
          : value}
        </span>
      </Table.Cell>
    );

    const selectedfont_size ="fontSize_"+this.props.userDetail.fontSize;
    const CloseIcon = <MUIIconWithTooltip icon={'Close'} className={`closeBtn`} title={i18next.t("close")}/>;
    const closeIconImg = <div className={styles.lmtCloseIconImg}><img width="16px" src="/images/close.png" /></div>;
    var OutstandingOrderHeader ='';
    if(this.props.userDetail.fontSize == 'S'){
      OutstandingOrderHeader = 'tradeBookHeaderSfont';
    } else if(this.props.userDetail.fontSize == 'N'){
      OutstandingOrderHeader = 'tradeBookHeaderMfont'
    } else{
      OutstandingOrderHeader = 'tradeBookHeaderLfont'
    }

    const rowStyle = theme => ({
      tableStriped:{
        '& tbody tr:nth-of-type(odd)':{
          //backgroundColor:this.props.selectedCssColorTheme.listRow.background,
          //color:this.props.selectedCssColorTheme.listRow.color
        },
        '& tbody tr:nth-of-type(even)':{
          //backgroundColor:this.props.selectedCssColorTheme.listRowNext.background,
          //color:this.props.selectedCssColorTheme.listRow.color
        },
        '& thead tr':{
         // backgroundColor:this.props.selectedCssColorTheme.trdbookHeader.background,
          ////color:this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        '& thead tr th':{
          //backgroundColor:this.props.selectedCssColorTheme.trdbookHeader.background,
          ////color:this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        '& .text-primary':{
         // color:this.props.selectedCssColorTheme.activeHeaderColor.color
        }
      },
    });

    const TableRow = props => {
      const { row } = props;
      if(row.deal === "BUY" || row.deal === "STOP BUY"){
        return <Table.Row  {...props}  className="blue" />;
      } else {
        return <Table.Row  {...props}  className="red" />;
      }
      return <Table.Row {...props} />;
    };

    const dropDownListColor =theme =>({
      dropDownListHoverMenu:{
        '& .dropdown-item':{
          // background:this.props.selectedCssColorTheme.dropDownList.background,
          // color:this.props.selectedCssColorTheme.dropDownList.color
        },
        '& :hover':{
          // background:this.props.selectedCssColorTheme.dropDownListHover.background,
          // color:this.props.selectedCssColorTheme.dropDownListHover.color
        }
      }
    });

    const ContainerColor = ({ classes, ...restProps }) => (
      <ColumnChooser.Container {...restProps} className={classes.dropDownListHoverMenu}  />
    );

    const MenuColor = props => (
      <ColumnChooser.Item {...props} />
    );


    const TableComponentBase = ({ classes, ...restProps }) => (
      <Table.Table
        {...restProps}
        id="limitOrdTable" className={classes.tableStriped}
      />
    );

    const searchPlaceholderMsg = {
      searchPlaceholder:(i18next.t('search'))+'...',
    };
    var NoDataMsg = {
      noData:'',
    }
    if (this.state.refreshIconFlag === true) {
      NoDataMsg.noData = '';
    }
    else {
      NoDataMsg.noData = (i18next.t('noDataAvlMsg'));
    }

    const NoDataCell = props => (
      <Table.NoDataCell {...props} className="noDataCell" />
    );
    if(this.state.cancelLMTModel === true || this.props.requestRejectModal.OMT===2){
      if(this.props.requestRejectModal.title !== '' && this.props.requestRejectModal.OT !== 4){
        if(this.props.requestRejectModal.bcm==='107' || this.props.requestRejectModal.bcm==='106' || this.props.requestRejectModal.bcm==='109') {
          ordRectFlag=true;
        }
      }
    }

    const cancelModalColumn=[
      {name:'orderNo', title:i18next.t('orderNo')},
      {name:'deal', title:i18next.t('deal')},
      {name:'cmdtyPair', title:i18next.t('cmdtyPair')},
      {name:'quantity', title:i18next.t('quantity')},
      {name:'qtyType', title:i18next.t('qtyType')},
      {name:'price', title:i18next.t('rate')},
      {name:'status_val', title:i18next.t('status')},
      {name:'reason', title:i18next.t('reason')}
    ];

    return (
      <div id="lmtOrderTbl" className={`${styles.trdbody} ${selectedfont_size} ${this.props.language}`}>
        {ordRectFlag === true ?
          <Modal isOpen={ordRectFlag === true} className={`${styles.warningModal}`} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.errorheader} errorheader`}>
                <span className={`${styles.errormsgTitle}`}>
                  {this.props.requestRejectModal.title}
                </span>
                <span className="modalCloseIcon" onClick={this.closeReqRejectModal}>{CloseIcon}</span>
              </div>
              <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
                <p>{i18next.t(this.props.requestRejectModal.msg)}</p>
              </div>
            </div>
          </Modal>
        : null}

        {this.props.lmtModifyFlag === true && this.state.enableLimitModifyFlag === true ?
          <Modal isOpen={this.props.lmtModifyFlag} id="lmtOrdModModal" className={this.state.Validty === 'GTD' ? `${styles.LMTcontentGTD}` : `${styles.LMTcontent}` } onAfterOpen={this.afterOpenModal}>
            {/*<div className={styles.header}>
              <p className={`${styles.msgTitle}`}>{i18next.t("Modify LMT Order")}</p>
              <span onClick={this.closeLimitOrdpopup}>{closeIconImg}</span>
            </div>*/}
            <div ref="errorMSG" className="mdlWrap ModifyOrdrModal" >
              <ModifyLMTOrderComponent selectLmtRow={this.state.orderSelection} />
            </div>
          </Modal>
        : null}

        {this.state.checkMultiCnclStatusMdl === true ?
          <Modal isOpen={this.state.checkMultiCnclStatusMdl} id="lmtOrdCanErrModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.errorheader} errorheader`}>
                <span className={`${styles.errormsgTitle}`}>{i18next.t("Error")}</span>
                <span className="modalCloseIcon" onClick={this.cancelMultiCancelModal} >{CloseIcon}</span>
              </div>
              <div className={`${styles.msgWrap} msgWrap`}>
                <h4>{i18next.t("Order Cancellation in process.")}.</h4>
              </div>
            </div>
          </Modal>
        : null}

        {this.state.statusFlag === true ?
          <Modal isOpen={this.state.statusFlag} id="lmtOrdCanStsModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.errorheader} errorheader`}>
                <span className={`${styles.errormsgTitle}`}>{i18next.t("error")}</span>
                <span className="modalCloseIcon" onClick={this.cancelStatusModal} >{CloseIcon}</span>
              </div>
              <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
                <h4>{i18next.t("noRatesMsg")}</h4>
              </div>
            </div>
          </Modal>
        : null}

        {this.state.cancelLMTModel === true ?
          <Modal isOpen={this.state.cancelLMTModel} id="lmtOrdMultiCanConfModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.errorheader} errorheader`}>
                {this.state.selectLMTKey ==='A'?this.state.selectedDocNo === '' ?
                  <span className={`${styles.errormsgTitle}`}>{i18next.t("cancelOrd")}</span>
                :
                  <span className={`${styles.errormsgTitle}`}>{i18next.t("cancelOrd")}:{" "+ this.state.selectedDocNo}</span>
                : this.state.selectedOrderNo === '' ?
                  <span className={`${styles.errormsgTitle}`}>{i18next.t("cancelOrd")}</span>
                :
                  <span className={`${styles.errormsgTitle}`}>{i18next.t("cancelOrd")}:{" "+this.state.selectedOrderNo}</span>
                }
                <span className="modalCloseIcon" onClick={this.cancelLmtCnfrmBox}>{CloseIcon}</span>
              </div>
              <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
                <h4>{i18next.t("cancelOrdConfrmMsg")}</h4>
              </div>
              <div className={this.props.language === 'AR'? `${styles.btnWrap} col-md-3 cancelConfrmBtn`:`${styles.btnWrap} col-md-12`}>
                <Button id="lmtOrdConfCanBtn" onClick={this.cancelLmtCnfrmBox} className={styles.clearBtn}>{i18next.t("no")}</Button>&nbsp;&nbsp;
                {this.state.orderSelection.length === 1 ? 
                  <Button id="lmtOrdConfSubBtn" className={`${styles.submitBtn} mr-3`} onClick={()=>this.cancelLIMITOrder(this.state.orderSelection)}>{i18next.t("yes")}</Button>
                    : <Button id="lmtOrdConfSubBtn" className={`${styles.submitBtn} mr-3`} onClick={()=>this.multipleCancelLIMITOrder(this.state.orderSelection)}>{i18next.t("yes")}</Button>}
              </div>
            </div>
          </Modal>
        : null}

        {this.state.multipleCancelModal === true ?
          <Modal isOpen={this.state.multipleCancelModal} id="lmtOrdMulCanModal" className={`${styles.multiCancelOrdModal} ${this.props.language}`} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className="cancelOrdDiv">
                <div className={`${styles.errorheader} errorheader`}>
                  <span className={`${styles.errormsgTitle}`}>{i18next.t("cancelOrd")}</span>
                  <span className="modalCloseIcon" onClick={this.closeMultipleCancelModal} >{CloseIcon}</span>
                </div>
                <div id="lmtOrdMulCanTbleDiv" className="cancelRowTblDiv">
                  <div className={`${styles.multipleCancelTable} ${OutstandingOrderHeader} ${selectedfont_size}`} id="mulCancelTbl">
                    <Card>
                      <Grid style={{height:'100%'}} rows={this.state.cancelModalrow} columns={cancelModalColumn} getRowId={getRowId}>
                        <DragDropProvider />
                        <SortingState onSortingChange={this.onChangeCancelModalSortiog} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="lmtChngOutLmtColSorting" />
                        <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                        <SearchState value={this.state.cancelModalSearchValue} onValueChange={this.onChangeCancelModalSearchValue} id="lmtChngOutlmtSearchVal" />
                        <IntegratedFiltering />
                        <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)}
                          rowComponent={TableRow} height="auto" columnAutoWidth={true} columnExtensions={this.props.language === 'AR' ? this.state.cancelModalExtensionsAR : this.state.cancelModalExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} />
                        <TableColumnReordering order={this.state.cancelModalColOrder} onOrderChange={this.onChangeCancelModalColOrder} id="lmtChngOutLmtColOrd" />
                        <TableHeaderRow showSortingControls contentComponent={TableHeaderContent}/>
                        <TableColumnVisibility />
                        <Toolbar />
                        <ColumnChooser  containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
                      </Grid>
                    </Card>
                  </div>
                </div>
                <div className={`${styles.cancelOrdBtnDiv} col-md-12`}>
                  {parseInt(this.props.status) === 1  &&
                    <div className={`${styles.netDiscMsg}`}>
                      {i18next.t('netDisconnectMsg')}
                    </div>
                  }
                  {this.state.stopBtnReplaceflag=== true?
                    <div className={`${styles.btnWrap}`}>
                      <Button  id="lmtOrdMulCanClsBtn" className='button-l lmtClose' onClick={this.closeBtnclick} bsStyle="primary">{i18next.t("close")}</Button>
                    </div>
                  :
                    <div className={`${styles.btnWrap}`}>
                      <Button  id="lmtOrdMulCanStpBtn" className='button-l lmtClose'onClick={this.stopBtnclick} bsStyle="primary">{i18next.t("stop")}</Button>
                    </div>
                  }
                </div>
              </div>
            </div>
          </Modal>
        : null }

        {this.state.disableModifyFlag === true ?
          <Modal isOpen={this.state.disableModifyFlag} id="lmtOrdEditErrModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.errorheader} errorheader`}>
                <span className={`${styles.errormsgTitle}`}>{i18next.t(this.state.lmtEditErrMsgHeader)}</span>
                <span className="modalCloseIcon" onClick={this.cancelDisableModifyModal} >{CloseIcon}</span>
              </div>
              <div className={`${styles.msgWrap} msgWrap commonMsgDir`}>
                <h4>{i18next.t(this.state.lmtEditErrMsg)}</h4>
              </div>
              <div className={`${styles.btnWrap} col-md-12`}>
                <Button id="lmtOrdEditSubmit" onClick={this.cancelDisableModifyModal} className='button-l lmtClose' bsStyle="primary">{i18next.t("OK")}</Button>
              </div>
            </div>
          </Modal>
        : null}

        {this.state.cancelAllDisableModal === true ?
          <Modal isOpen={this.state.cancelAllDisableModal} id="lmtCancelAllOrdModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
            <div ref="errorMSG" className="mdlWrap" >
              <div className={`${styles.errorheader} errorheader`}>
                <span className={`${styles.errormsgTitle}`}>{i18next.t(this.state.lmtEditErrMsgHeader)}</span>
                <span className="modalCloseIcon" onClick={this.closeCancelAllDisableModal} >{CloseIcon}</span>
              </div>
              <div className={`${styles.msgWrap}  msgWrap commonMsgDir`}>
                <h4>{i18next.t(this.state.lmtEditErrMsg)}</h4>
                <ul className={styles.listWrap}>
                  {this.state.inactiveAccOnOrders.length && this.state.inactiveAccOnOrders.map(item => (
                    <li>{item.D} {`(${item.C})`}</li>
                  ))}
                </ul>
              </div>
              <div className={`${styles.btnWrap} col-md-12`}>
                <Button id="lmtOrdEditSubmit" onClick={this.closeCancelAllDisableModal} className='button-l lmtClose' bsStyle="primary">{i18next.t("OK")}</Button>
              </div>
            </div>
          </Modal>
        : null}

        {this.state.selectLMTKey ==='A' || this.state.selectLMTKey === 'O'  ?
          <div className={`${styles.refresh_icon} refresh_icon`}>
            <span onClick={this.refreshComponentData} id="lmtRefreshCompData"><MUIIconWithTooltip icon={'Refresh'} style={this.props.selectedCssColorTheme.iconColor} className={`${styles.icon}`} title={i18next.t("refresh")}/></span>
            { !this.props.disableOrdModify ? <span  onClick={this.editLimitOrdModal} id="lmtEditOrdModal"><MUIIconWithTooltip icon={'Edit'} style={this.props.selectedCssColorTheme.iconColor} className={`${styles.icon}`} title={i18next.t("edit")}/></span>:null}
            <span onClick={this.cancelLmtOrdModal} id="lmtCancelOrd"><MUIIconWithTooltip icon={'Close'} style={this.props.selectedCssColorTheme.iconColor} className={`${styles.icon}`} title={i18next.t("cancel")}/></span>
          </div>
        :
          <div className={`${styles.refresh_icon} refresh_icon`}>
            <span onClick={this.refreshComponentData} id="lmtRefresh"><MUIIconWithTooltip icon={'Refresh'} style={this.props.selectedCssColorTheme.iconColor} className={`${styles.icon}`} title={i18next.t("refresh")}/></span>
          </div>
        }

        <div className={`${styles.orderRowsCount} orderRowsCount`} >
          <span className="trdbookText">{i18next.t("count")}</span>: <span>{this.state.ordbookTableRowCount}</span>
        </div>

        <div id="lmtOrdTypeList" className={`${styles.trade_filter} lmtOrderStatus ${this.props.language}`}>
          <ButtonToolbar>
            <DropdownButton title={i18next.t(this.state.selectLMT)} id="dropdown-size-small" className={`${styles.btnToolbar} ${selectedfont_size} lmtOrdDropdown btnText`}>
            <MenuItem eventKey="1" className={`${selectedfont_size}`} onClick={() => this.selectLMT("all", "A")} id="lmtselectAll">{i18next.t("all")}</MenuItem>
            <MenuItem eventKey="2" className={`${selectedfont_size}`} onClick={() => this.selectLMT("outstanding", "O")} id="lmtselectWorking">{i18next.t("outstanding")}</MenuItem>
            <MenuItem eventKey="3" className={`${selectedfont_size}`} onClick={() => this.selectLMT("filled", "F")} id="lmtselectFilled">{i18next.t("filled")}</MenuItem>
            <MenuItem eventKey="4" className={`${selectedfont_size}`} onClick={() => this.selectLMT("cancelled", "C")} id="lmtselectCancelled">{i18next.t("cancelled")}</MenuItem>
            <MenuItem eventKey="5" className={`${selectedfont_size}`} onClick={() => this.selectLMT("expired", "E")} id="lmtselectExpired">{i18next.t("expired")}</MenuItem>
            </DropdownButton>
          </ButtonToolbar>
        </div>

        {this.state.selectLMTKey === 'A' ?
          <div className={`${styles.OutstandingOrderHeader} ${OutstandingOrderHeader} ${selectedfont_size} `} id="allLimitTbl" style={this.props.selectedLang.widgetwrapper}>
            <Card>
              <Grid style={{height:'100%'}} rows={this.state.allLmtOrdersRows} columns={this.state.allLmtOrderColumns} getRowId={getRowId}>
                <DragDropProvider />
                <SearchState value={this.state.allLmtSearchValue} onValueChange={this.onChangeAllLmtSearchValue} id="lmtChngAllLmtSearchVal" />
                <SortingState onSortingChange={this.onChangeAllLmtColSorting} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="lmtChngAllLmtColSorting" />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                <IntegratedFiltering />
                <SelectionState  selection={this.state.orderSelection} onSelectionChange={this.changeAllColSelection} />
                <PatchedIntegratedSelection rowSelectionEnabled={rowSelectionEnabled}/>
                <Table cellComponent={AllOrdersCell} height="auto" columnAutoWidth={true} rowComponent={TableRow}
                tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} columnExtensions={this.props.language === 'AR' ? this.state.allLmtOrderColumnExtensionsAR : this.state.allLmtOrderColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} />
                <TableColumnReordering order={this.state.allLmtColumnOrder} onOrderChange={this.onChangeAllLmtColOrder} id="lmtChngAllLmtColOrd" />
                <TableHeaderRow showSortingControls contentComponent={TableHeaderContent}/>
                <PatchedTableSelection  rowSelectionEnabled={rowSelectionEnabled} showSelectAll/>
                <TableColumnVisibility columnExtensions={this.state.colVisibilityExtensions} hiddenColumnNames={this.state.hiddenAllLmtOrderColNames} onHiddenColumnNamesChange={this.onChangeHiddenAllLmtCol} id="lmtChngHiddenAlllmtCol" />
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </Card>
          </div>
        : null}

        {this.state.selectLMTKey === 'O' ?
          <div className={`${styles.OutstandingOrderHeader} ${OutstandingOrderHeader} ${selectedfont_size} `} id="outLimitTbl" style={this.props.selectedLang.widgetwrapper}>
            <Card>
              <Grid style={{height:'100%'}} rows={this.state.outstngLmtOrderRows} columns={this.state.outLmtOrdcolumns} getRowId={getRowId}>
                <DragDropProvider />
                <SortingState onSortingChange={this.onChangeOutLmtColSorting} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="lmtChngOutLmtColSorting"/>
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions}/>
                <SearchState value={this.state.outLmtSearchValue} onValueChange={this.onChangeOutLmtSearchValue} id="lmtChngOutlmtSearchVal" />
                <IntegratedFiltering />
                <SelectionState  selection={this.state.orderSelection} onSelectionChange={this.changeOutColSelection} />
                <IntegratedSelection />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} height="auto" columnAutoWidth={true} rowComponent={TableRow} columnExtensions={this.props.language === 'AR' ? this.state.outLmtOrdColumnExtensionsAR : this.state.outLmtOrdColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} cellComponent={Cell} />
                <TableColumnReordering order={this.state.outLmtColumnOrder} onOrderChange={this.onChangeOutLmtColOrder} id="lmtChngOutLmtColOrd" />
                <TableHeaderRow showSortingControls contentComponent={TableHeaderContent} />
                <TableSelection showSelectAll />
                <TableColumnVisibility columnExtensions={this.state.colVisibilityExtensions} hiddenColumnNames={this.state.hiddenOutLmtColumnNames} onHiddenColumnNamesChange={this.onChangeHiddenOutLmtCol} id="lmtChngHiddenAllLmtColmn" />
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} />
                <ColumnChooser  containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </Card>
          </div>
        : null}

        {this.state.selectLMTKey === 'F' ?
          <div className={`${styles.OutstandingOrderHeader} ${OutstandingOrderHeader} ${selectedfont_size} `} id="FilledLimitTbl" style={this.props.selectedLang.widgetwrapper}>
            <Card>
              <Grid style={{height:'100%'}} rows={this.state.lmtOrderFilledrows} columns={this.state.filledLmtOrderColumns}>
                <DragDropProvider />
                <SortingState onSortingChange={this.onChangeFillColSorting} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="lmtChngFillColSort" />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                <SearchState value={this.state.filledLmtSearchValue} onValueChange={this.onChangeFilledSearchValue} id="lmtChngFillSearchVal" />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} rowComponent={TableRow} height="auto" columnAutoWidth={true} columnExtensions={this.props.language === 'AR' ? this.state.filledLmtOrdColumnExtensionsAR : this.state.filledLmtOrdColumnExtensions} cellComponent={FillOrdersCell} messages={NoDataMsg} noDataCellComponent={NoDataCell} />
                <TableColumnReordering order={this.state.filledLmtColOrder} onOrderChange={this.onChangeFilledLmtColOrder} id="lmtChngFilledLmtColOrd" />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.hiddenFilledOrderColNames} onHiddenColumnNamesChange={this.onChangeHiddenFilledCol} id="lmtChngHiddenFilledCol" />
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} />
                <ColumnChooser  containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </Card>
          </div>
        :null}

        {this.state.selectLMTKey === 'C' ?
          <div className={`${styles.OutstandingOrderHeader} ${OutstandingOrderHeader} ${selectedfont_size} `} id="cancelledLimitTbl" style={this.props.selectedLang.widgetwrapper}>
            <Card>
              <Grid style={{height:'100%'}} rows={this.state.lmtCancelledOrderRows} columns={this.state.cancelledLmtOrderColumns}>
                <DragDropProvider />
                <SortingState onSortingChange={this.onChangeCancelColSorting} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="lmtChngCancelColSort" />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                <SearchState value={this.state.cancelledLmtSearchValue} onValueChange={this.onChangeCancelSearchValue} id="lmtChngCancelSearchVal" />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} height="auto" rowComponent={TableRow}  columnAutoWidth={true} columnExtensions={this.props.language === 'AR' ? this.state.cancelledLmtOrdColumnExtensionsAR : this.state.cancelledLmtOrdColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} cellComponent={Cell} />
                <TableColumnReordering order={this.state.cancelledLmtColOrder} onOrderChange={this.onChangeCancelColOrder} id="lmtChngCancelColOrd" />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.hiddenCancelledLmtOrderColNames} onHiddenColumnNamesChange={this.onChangeHiddenCancelCol} id="lmtChngHiddenCancelCol" />
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} />
                <ColumnChooser  containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </Card>
          </div>
        : null}

        {this.state.selectLMTKey === 'E' ?
          <div className={`${styles.OutstandingOrderHeader} ${OutstandingOrderHeader} ${selectedfont_size}`} id="expiredLmtTbl" style={this.props.selectedLang.widgetwrapper}>
            <Card>
              <Grid style={{height:'100%'}} rows={this.state.lmtExpiredOrderRows} columns={this.state.expiredLmtOrderColumns}>
                <DragDropProvider />
                <SortingState onSortingChange={this.onChangeExpiredColSorting} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="lmtChngExpiredColsort" />
                <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
                <SearchState value={this.state.expiedLmtSearchValue} onValueChange={this.onChangeExpiredSearchValue} id="lmtChngExpiredSearchVal" />
                <IntegratedFiltering />
                <Table tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)} height="auto" columnAutoWidth={true} rowComponent={TableRow}  columnExtensions={this.props.language === 'AR' ? this.state.expiredLmtOrdColumnExtensionsAR : this.state.expiredLmtOrdColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell} cellComponent={Cell} />
                <TableColumnReordering order={this.state.expiredLmtColOrder} onOrderChange={this.onChangeExpiredColOrder} id="lmtChngexpiredColOrd" />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility hiddenColumnNames={this.state.hiddenExpiredColumnNames} onHiddenColumnNamesChange={this.onChangeHiddenExpiredCol} id="lmtChngHiddenExpiredCol" />
                <Toolbar />
                <SearchPanel messages={searchPlaceholderMsg} />
                <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
              </Grid>
            </Card>
          </div>
        : null}

        {this.state.refreshIconFlag === true ?
          <div id="overlay" >
            <i className="fa fa-spinner fa-spin spin-big"></i>
          </div>
        : null}
      </div>
    );
  }
}
